import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { CardDb } from '../redux/cardDbSlice';

const useAllCardDbsBySheetIds = (sheetIds: string[] | null) : [string[], CardDb[]] => {
  const cards = useSelector((state: RootState) => state.cardDb).cards;

  let ids: string[] = new Array(0);
  sheetIds?.map((sheetId) => {
    const cardIds = Object.keys(cards).filter(id => cards[id].sheetId === sheetId);
    cardIds.forEach(id => ids.push(id));
  })  
  const values = ids.map(id => cards[id]);

  return [ids, values];
}

export default useAllCardDbsBySheetIds;
